import { styled, NamedSection as BaseNamedSection } from '@innowise-group/mui-kit';

export const NamedSection = styled(BaseNamedSection)`
  padding: 0.75rem;
  margin-top: 0.5rem;
`;
